import * as dateTimeUtils from '../../../common/utils/dateTimeUtils';

export function sortMicroCampaigns(microCampaigns) {
  if (microCampaigns && typeof microCampaigns !== 'string') {
    return dateTimeUtils.sortArrayByDate(microCampaigns, ['created', 'date'], -1);
  }
  return null;
}
